import { atom } from 'jotai';

export const notifyCacheRefreshAtom = atom(null);

export const notifyEndCallAtom = atom(null);

export const notifyStartCallAtom = atom(null);
export const notifyUpdateCallAtom = atom(null);

export const notifyIncomingCallAtom = atom(null);

export const notifySMSSentAtom = atom(null);

export const notifySMSReceivedAtom = atom(null);

export const notifyClosePopUpAtom = atom(null);
